// Generated by `pnpm gen:svg` from src/assets/svg — do not edit.
import type { SVGProps } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  ref?: Ref<SVGSVGElement>;
}
const SvgHeadphones = ({
  title,
  titleId,
  ref,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    id="Vrstva_1"
    data-name="Vrstva 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="310 212 220 220"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <defs>
      <style>{`
.hp-1 {
  stroke: #fff;
  stroke-width: 0.25px;
}

.hp-1,
.hp-2,
.hp-3,
.hp-4 {
  stroke-miterlimit: 10;
}

.hp-5,
.hp-3 {
  fill: #fff;
}

.hp-6 {
  fill: #484747;
}

.hp-7 {
  fill: #f39ee5;
}

.hp-2,
.hp-3 {
  stroke: #000;
  stroke-width: 0.5px;
}

.hp-8 {
  opacity: 0.4;
}

.hp-8,
.hp-4 {
  fill: var(--mascot-accent, #ff49a4);
}

.hp-4 {
  stroke: #575756;
  stroke-width: 0.75px;
}
`}</style>
    </defs>
    <path
      className="hp-5"
      d="M525.21,325.73c0,35.48-17.52,66.86-44.39,85.97-.72.51-1.45,1.01-2.18,1.5-1.04.71-2.1,1.4-3.17,2.06-13.76,8.58-29.64,14.08-46.68,15.51-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-19.65-.8-37.91-6.99-53.35-17.14-.02-.01-.03-.02-.05-.03-.23-.16-.48-.31-.71-.48-28.26-18.9-46.88-51.12-46.88-87.68,0-58.22,47.2-105.43,105.42-105.43s105.43,47.21,105.43,105.43Z"
    />
    <path
      className="hp-8"
      d="M525.21,325.73c0,35.48-17.52,66.86-44.39,85.97-.72.51-1.45,1.01-2.18,1.5-1.04.71-2.1,1.4-3.17,2.06-13.76,8.58-29.64,14.08-46.68,15.51-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-19.65-.8-37.91-6.99-53.35-17.14-.02-.01-.03-.02-.05-.03-.23-.16-.48-.31-.71-.48-28.26-18.9-46.88-51.12-46.88-87.68,0-58.22,47.2-105.43,105.42-105.43s105.43,47.21,105.43,105.43Z"
    />
    <path d="M498.45,370.71c.6-1.93-6.93-11.35-12.15-17.72-5.22-6.35-10.81-13.36-16.47-18.82-2.32-2.25-5.68-5.32-8.83-8.13-.69-.65-1.37-1.26-2.02-1.84-2.19-1.93-4.09-3.61-5.27-4.65-.79-.7-1.25-1.1-1.25-1.1,0,0-1.44,12.67-.73,18.3.02.18.04.33.08.49.77,5.59,3.02,13.06,7.25,18.14.74.87,1.47,1.67,2.26,2.42.47.44.95.89,1.44,1.31.46.4.99.81,1.55,1.23.72.57,1.45,1.11,2.19,1.65.11.07.22.16.33.25.3.21.57.42.87.63,1.64,1.15,3.3,2.32,4.98,3.67.25.18.48.38.72.57.28.25.54.47.8.69,5.41,4.69,13.04,12.07,15.01,11.38,1.98-.71,8.65-6.53,9.24-8.47Z" />
    <path d="M342.19,370.71c-.6-1.93,6.93-11.35,12.15-17.72,5.22-6.35,10.81-13.36,16.47-18.82,2.32-2.25,5.68-5.32,8.83-8.13.69-.65,1.37-1.26,2.02-1.84,2.19-1.93,4.09-3.61,5.27-4.65.79-.7,1.25-1.1,1.25-1.1,0,0,1.44,12.67.73,18.3-.02.18-.04.33-.08.49-.77,5.59-3.02,13.06-7.25,18.14-.74.87-1.47,1.67-2.26,2.42-.47.44-.95.89-1.44,1.31-.46.4-.99.81-1.55,1.23-.72.57-1.45,1.11-2.19,1.65-.11.07-.22.16-.33.25-.3.21-.57.42-.87.63-1.64,1.15-3.3,2.32-4.98,3.67-.25.18-.48.38-.72.57-.28.25-.54.47-.8.69-5.41,4.69-13.04,12.07-15.01,11.38-1.98-.71-8.65-6.53-9.24-8.47Z" />
    <path
      className="hp-5"
      d="M478.64,413.2c-1.04.71-2.1,1.4-3.17,2.06-13.76,8.58-29.64,14.08-46.68,15.51-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-19.65-.8-37.91-6.99-53.35-17.14-.02-.01-.03-.02-.05-.03-1.62-8.54-1.75-17.67.06-27.08,1.24-6.46,2.68-12.81,4.35-18.94.83-3.07,1.72-6.09,2.67-9.04.04-.12.08-.25.12-.37,4.8-14.93,11.07-28.1,19.08-37.74.06-.07.11-.13.17-.2,8.55-10.21,19.09-16.41,31.93-16.46h.16c12.64,0,23.23,5.72,31.86,15.41.34.37.67.75,1,1.14,7.92,9.3,14.15,21.98,18.77,36.61,1.19,3.74,2.27,7.62,3.23,11.59,1.43,5.8,2.63,11.83,3.62,18,1.46,9.18,1.23,18.06-.33,26.39Z"
    />
    <path
      className="hp-2"
      d="M471.81,357.22c-9.18,18.77-28.93,31.75-51.8,31.75s-41.76-12.42-51.17-30.51c9.97-31,26.27-54.4,51.34-54.4s41.85,22.22,51.63,53.16Z"
    />
    <path
      className="hp-1"
      d="M456.7,312.15s.07-.01.07-.01c-4.94,15.56-15.54,25.7-18.9,36.86-4.48,14.85-5.83,30.14-7.1,31.52-2.55,2.73-17.79,2.73-21.17,0-1.7-1.38-1.18-15.87-6.25-29.07-5.76-14.95-6.58-17.18-13.97-28.65.01-.03.03-.07.07-.1-4.48-6.82-10.76-19.49-10.76-31.01,0-25.78,18.41-46.67,41.09-46.67s41.09,20.9,41.09,46.67c0,7.35-1.5,14.31-4.17,20.48Z"
    />
    <g>
      <path
        className="hp-7"
        d="M388.69,306.73c1.32-.55,2.22-1.09,2.75-2.41.54-1.32.27-2.33-.3-3.63-.57-1.31-1.99-2.52-3.21-3.04-1.22-.52-2.06-.71-3.36-.47-1.3.24-3.33,1.52-3.82,2.86-.49,1.34-.27,2.33.3,3.63.57,1.31,1.6,2.4,3.2,3.04,1.61.64,3.1.57,4.43.02Z"
      />
      <path
        className="hp-7"
        d="M450.59,306.68c-1.34-.52-2.24-1.05-2.8-2.35-.56-1.31-.32-2.32.23-3.64.55-1.32,1.94-2.56,3.15-3.1,1.2-.55,2.04-.75,3.35-.54,1.31.21,3.36,1.45,3.88,2.78.51,1.33.32,2.32-.23,3.64-.55,1.32-1.55,2.43-3.14,3.1-1.59.67-3.09.63-4.43.11Z"
      />
    </g>
    <rect
      className="hp-4"
      x={467.26}
      y={270.85}
      width={10.53}
      height={30.19}
      rx={5.27}
      ry={5.27}
      transform="translate(-24.6 45.29) rotate(-5.35)"
    />
    <path
      className="hp-4"
      d="M473.21,300.99c-.45,2.62-2.61,4.74-5.4,5.01-.58.06-1.15.03-1.7-.08-.86-.16-1.66-.52-2.35-1.01-.66-.46-1.22-1.05-1.64-1.74-.49-.77-.8-1.65-.88-2.62l-.08-.9-2.43-25.93c-.17-1.8.47-3.49,1.62-4.71.84-.89,1.95-1.53,3.22-1.77.2-.05.4-.08.61-.09.2-.02.39-.03.58-.03.07,0,.13,0,.2,0,1.66.05,3.17.78,4.24,1.94.52.57.94,1.24,1.21,1.98.19.49.31,1,.36,1.55l2.51,26.83c.05.53.03,1.07-.06,1.57Z"
    />
    <rect
      className="hp-4"
      x={361.61}
      y={270.85}
      width={10.53}
      height={30.19}
      rx={5.27}
      ry={5.27}
      transform="translate(705.49 604.85) rotate(-174.65)"
    />
    <path
      className="hp-4"
      d="M380.68,273.71l-2.43,25.95-.08.88c-.08.89-.36,1.72-.78,2.45-.44.76-1.03,1.42-1.74,1.91-.66.47-1.4.81-2.2.98-.59.13-1.22.17-1.86.11-2.78-.26-4.95-2.37-5.4-5.01-.08-.51-.1-1.04-.06-1.57l2.51-26.83c.06-.54.18-1.06.36-1.55.27-.74.69-1.41,1.22-1.98,1.11-1.21,2.69-1.94,4.41-1.95h.02c.19,0,.38,0,.58.03.21.02.41.05.61.09,1.32.25,2.48.95,3.33,1.9,1.09,1.21,1.68,2.84,1.52,4.57Z"
    />
    <path
      className="hp-6"
      d="M396.62,254.11c-4.12,3.38-7.98,7.54-10.75,12.39-3.6-1.73-7.31-4.1-7.85-6.61-.98-4.62,1.02-9.44,3.94-11.41,2.92-1.97,5.53-2.06,8.95-1.18,1.67.42,3.89,3.64,5.7,6.81Z"
    />
    <path
      className="hp-6"
      d="M461.87,259.9c-.53,2.5-4.76,4.88-8.36,6.61-2.76-4.85-5.96-8.13-10.07-11.51,1.81-3.17,3.87-7.27,5.54-7.69,3.43-.88,6.03-.79,8.95,1.18,2.92,1.97,4.92,6.79,3.94,11.41Z"
    />
    <path
      className="hp-4"
      d="M461.57,260.72c-3.27-5.23-7.45-9.8-12.31-13.48-8.24-6.25-18.44-9.94-29.47-9.94s-21.18,3.67-29.4,9.88c-4.81,3.62-8.95,8.12-12.2,13.26-1.35,2.12-2.54,4.35-3.57,6.67h.02c.19,0,.38,0,.58.03.21.02.41.05.61.09,1.32.26,2.48.95,3.33,1.91.77-1.71,1.64-3.36,2.61-4.95,3.25-5.37,7.57-9.99,12.65-13.56,7.2-5.09,15.94-8.06,25.37-8.06s18.6,3.13,25.91,8.46c4.84,3.52,8.96,7.99,12.1,13.16.94,1.54,1.79,3.15,2.55,4.81.84-.89,1.95-1.52,3.21-1.77.2-.04.41-.07.61-.09.2-.02.4-.03.58-.03.07,0,.13,0,.2,0-.98-2.22-2.12-4.36-3.38-6.4Z"
    />
    <path
      className="hp-3"
      d="M394.49,285.27c.09-5.52-4.33-10.06-9.87-10.15-5.54-.09-10.1,4.32-10.18,9.83-.09,5.52,4.33,10.06,9.87,10.15,5.54.09,10.1-4.32,10.18-9.83Z"
    />
    <path d="M385.42,293.5c4.52.7,8.37-3.13,7.68-7.63-.43-2.81-2.73-5.09-5.53-5.53-4.52-.7-8.37,3.12-7.68,7.63.43,2.81,2.73,5.09,5.53,5.53Z" />
    <path
      className="hp-3"
      d="M464.69,285.27c.09-5.52-4.33-10.06-9.87-10.15-5.54-.09-10.1,4.32-10.18,9.83-.09,5.52,4.33,10.06,9.87,10.15,5.54.09,10.1-4.32,10.18-9.83Z"
    />
    <path d="M451.55,293.14c4.53.7,8.37-3.13,7.67-7.63-.43-2.81-2.73-5.09-5.53-5.52-4.52-.7-8.37,3.13-7.67,7.63.43,2.81,2.73,5.09,5.53,5.52Z" />
  </svg>
);
export { SvgHeadphones };
